import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Breadcrumbs,
  Link,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Divider,
  Grid,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";

const ViewMore = () => {
  const navigate = useNavigate();
  const stateName = sessionStorage.getItem("selectedState");
  const siteId = sessionStorage.getItem("selectedSiteId");
  const [statusClass, setStatusClass] = useState("offline");
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [controllerDate, setControllerDate] = useState("");
  const [isOnline, setIsOnline] = useState(false);
  const [hupsdata, setHupsData] = useState(null);
  const [dateTime, setDateTime] = useState("");
  const [initialLoading, setInitialLoading] = useState(true);
  const [alarmsDialogOpen, setAlarmsDialogOpen] = useState(false);
  const battStatusMap = {
    0: "Standby",
    1: "Charging",
    2: "Discharging",
    3: "Unknown",
  };


  // const battWarningMap = {
  //   0: "Over Cell Voltage Warning",
  //   1: "Low Cell Voltage Warning",
  //   2: "Over Voltage Warning",
  //   3: "Low Voltage Warning",
  //   4: "Discharge Over Current Warning",
  //   5: "Charge Over Current Warning",
  //   6: "Discharge Over Temp Warning",
  //   7: "Discharge Low Temp Warning",
  //   8: "Charge Over Temp Warning",
  //   9: "Charge Low Temp Warning",
  //   10: "MOSFET Over Temp Warning",
  //   11: "Environment Over Temp Warning",
  //   12: "BMS Communication Lost",
  //   13: "Low SOC Warning",
  //   17: "Normal",
  // };
  // const battProtectionMap = {
  //   0: "Discharge Over Current Protection",
  //   1: "Short Circuit Protection",
  //   2: "Over Cell Voltage Protection",
  //   3: "Low Cell Voltage Protection",
  //   4: "Discharge Over Temp Protection",
  //   5: "Charge Over Temp Protection",
  //   6: "Discharge Low Temp Protection",
  //   7: "Charge Low Temp Protection",
  //   8: "Over Voltage Protection",
  //   9: "Low Voltage Protection",
  //   10: "Charge Over Current Protection",
  //   11: "MOSFET Over Temp Protection",
  //   12: "Environment Over Temp Protection",
  //   13: "Cell Delta Protection",
  //   17: "Normal",
  // };
  const warningList = [
    { key: "warn_over_cell_voltage", label: "Over Cell Voltage Warning" },
    { key: "warn_low_cell_voltage", label: "Low Cell Voltage Warning" },
    { key: "warn_over_voltage", label: "Over Voltage Warning" },
    { key: "warn_low_voltage", label: "Low Voltage Warning" },
    {
      key: "warn_discharge_over_current",
      label: "Discharge Over Current Warning",
    },
    { key: "warn_charge_over_current", label: "Charge Over Current Warning" },
    { key: "warn_discharge_over_temp", label: "Discharge Over Temp Warning" },
    { key: "warn_discharge_low_temp", label: "Discharge Low Temp Warning" },
    { key: "warn_charge_over_temp", label: "Charge Over Temp Warning" },
    { key: "warn_charge_low_temp", label: "Charge Low Temp Warning" },
    { key: "warn_mosfet_over_temp", label: "MOSFET Over Temp Warning" },
    {
      key: "warn_environment_over_temp",
      label: "Environment Over Temp Warning",
    },
    { key: "warn_bms_comm_lost", label: "BMS Communication Lost" },
    { key: "warn_low_soc", label: "Low SOC Warning" },
  ];

  const protectionList = [
    {
      key: "prot_discharge_over_current",
      label: "Discharge Over Current Protection",
    },
    { key: "prot_short_circuit", label: "Short Circuit Protection" },
    { key: "prot_over_cell_voltage", label: "Over Cell Voltage Protection" },
    { key: "prot_low_cell_voltage", label: "Low Cell Voltage Protection" },
    {
      key: "prot_discharge_over_temp",
      label: "Discharge Over Temp Protection",
    },
    { key: "prot_charge_over_temp", label: "Charge Over Temp Protection" },
    { key: "prot_discharge_low_temp", label: "Discharge Low Temp Protection" },
    { key: "prot_charge_low_temp", label: "Charge Low Temp Protection" },
    { key: "prot_over_voltage", label: "Over Voltage Protection" },
    { key: "prot_low_voltage", label: "Low Voltage Protection" },
    {
      key: "prot_charge_over_current",
      label: "Charge Over Current Protection",
    },
    { key: "prot_mosfet_over_temp", label: "MOSFET Over Temp Protection" },
    {
      key: "prot_environment_over_temp",
      label: "Environment Over Temp Protection",
    },
    { key: "prot_cell_delta", label: "Cell Delta Protection" },
  ];

  // console.log(siteId);
  useEffect(() => {
    const userData = sessionStorage.getItem("userData");
    if (!userData) {
      navigate("/");
    } else {
      sessionStorage.setItem("lastVisitedPage", "/get_data_by_site");
    }
  }, [navigate]);
  useEffect(() => {
    const fetchHupsData = async () => {
      const fetchUrlHups = `https://api.bharatnet.sunshineiotronics.com/api/v2/hups/${siteId}`;
      try {
        const response = await fetch(fetchUrlHups);
        const result = await response.json();

        if (result && result.controller_datetime) {
          setHupsData(result);
          setControllerDate(result.controller_datetime);

          const currentDate = new Date();
          const siteDate = new Date(
            result.controller_datetime
              .split(" ")[0]
              .split("-")
              .reverse()
              .join("-") +
            " " +
            result.controller_datetime.split(" ")[1],
          );

          setDateTime(result.controller_datetime);

          const diffSeconds = Math.floor((currentDate - siteDate) / 1000);
          console.log(`Time difference in seconds: ${diffSeconds}`);

          if (diffSeconds <= 300) {
            setIsOnline(true);
            setStatusClass("online");
          } else {
            setIsOnline(false);
            setStatusClass("offline");
          }
        }
      } catch (error) {
        console.error("Error fetching hupsdata:", error);
        setHupsData(null);
      }
    };
    const fetchData = async () => {
      await fetchHupsData();
    };

    const fetchInitialData = async () => {
      setInitialLoading(true);
      await fetchData();
      setInitialLoading(false);
    };

    // Fetch initial data
    fetchInitialData();
    // Set interval to fetch data every 3 seconds
    const intervalId = setInterval(fetchData, 3000);

    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, [siteId]);

  if (initialLoading || !hupsdata) {
    return <div>Loading...</div>;
  }
  const breadcrumbs = [
    <Link key="1" sx={{ color: "black" }} href="/dashboard">
      Dashboard
    </Link>,
    <Link key="2" sx={{ color: "black" }} href={`/dashboard`}>
      {stateName}
    </Link>,
    <Link key="3" sx={{ color: "black" }} href={`/${stateName}/displaySite`}>
      Display Sites
    </Link>,
    <Link key="4" sx={{ color: "black" }} href={`/get_data_by_site`}>
      Go Live
    </Link>,
    <Typography key="5" sx={{ color: "text.primary" }}>
      View More
    </Typography>,
  ];
  const alarmStatus = (value) => (
    <div className={`status-indicator ${value == 1 ? "offline" : "online"}`}>
      <div className="status-light"></div>
    </div>
  );

  const alarmShow = (value) => {
    if (value == 1) {
      return "Normal";
    } else if (value == 0) {
      return "Fail";
    }
  };

  const workParam = (value) => {
    if (value == 1) {
      return "Working";
    } else if (value == 0) {
      return "Fail";
    }
  };


  const StatusBadge = ({ value, type = "alarm" }) => {
    let bgColor, textColor;
    if (type === "alarm") {
      bgColor = value === "Fail" ? "#ffebee" : "#e8f5e9";
      textColor = value === "Fail" ? "#c62828" : "#2e7d32";
    } else if (type === "warning") {
      bgColor = value === "Warning" ? "#fff3e0" : "#e8f5e9";
      textColor = value === "Warning" ? "#e65100" : "#2e7d32";
    } else if (type === "protection") {
      bgColor = value === "Active" ? "#fce4ec" : "#e8f5e9";
      textColor = value === "Active" ? "#c2185b" : "#2e7d32";
    } else {
      bgColor = "#e3f2fd";
      textColor = "#1565c0";
    }
    
    return (
      <Box
        sx={{
          display: "inline-block",
          px: 1,
          py: 0.25,
          borderRadius: 1,
          fontWeight: 600,
          fontSize: "10px",
          backgroundColor: bgColor,
          color: textColor,
        }}
      >
        {value}
      </Box>
    );
  };

  const parseBatteryCapacity = (value) => {
    if (!value && value !== 0) return "N/A";
    // Format: 4850 -> 48V, 50AH
    const voltage = Math.floor(value / 100);
    const capacity = value % 100;
    return `${voltage}V, ${capacity}AH`;
  };

  const batteryCurrent = (value) => {
    if (value === null || value === undefined) return "N/A";
    // 0-32767: Charge, 32768-65535: Discharge
    if (value >= 0 && value <= 32767) {
      return "Charge";
    } else if (value >= 32768 && value <= 65535) {
      return "Discharge";
    }
    return "Unknown";
  };

  // Helper component for table sections
  const DataTable = ({ title, children, noScroll = false }) => (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Typography
        variant="h6"
        sx={{
          textAlign: "center",
          mb: 1,
          color: "#997D3D",
          fontWeight: 600,
          fontSize: { xs: "16px", sm: "18px", md: "20px" },
        }}
      >
        {title}
      </Typography>
      <TableContainer 
        component={Paper} 
        sx={noScroll ? { flex: 1, overflow: "auto", minHeight: 0 } : { maxHeight: "600px", overflow: "auto", flex: 1, minHeight: 0 }}
      >
        <Table size="small" stickyHeader>
          <TableHead sx={{ backgroundColor: "rgb(250, 223, 186)" }}>
            <TableRow>
              <TableCell sx={{ fontSize: { xs: "12px", sm: "14px" }, color: "#997D3D", fontWeight: 600, backgroundColor: "rgb(250, 223, 186)" }}>
                Parameter
              </TableCell>
              <TableCell sx={{ fontSize: { xs: "12px", sm: "14px" }, color: "#997D3D", fontWeight: 600, backgroundColor: "rgb(250, 223, 186)" }}>
                Value
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>{children}</TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  return (
    <Box sx={{ p: { xs: 1, sm: 2, md: 2 } }}>
      <Box display="flex" flexDirection="column" gap={2}>
        <Box 
          display="flex" 
          justifyContent="space-between" 
          alignItems="center"
          flexDirection={{ xs: "column", sm: "row" }}
          gap={1}
        >
          <Stack spacing={1}>
            <Breadcrumbs
              separator={<NavigateNextIcon fontSize="small" />}
              aria-label="breadcrumb"
            >
              {breadcrumbs}
            </Breadcrumbs>
          </Stack>
          <Typography
            variant="body2"
            sx={{ color: "text.secondary", fontWeight: "bold" }}
          >
            <div className={`status-indicator ${statusClass}`}>
              <div className="status-light"></div>
              <span className="status-text">
                {siteId} | {hupsdata?.controller_datetime || ""}{" "}
              </span>
            </div>
          </Typography>
        </Box>
        <Divider sx={{ borderColor: "divider" }} />
        
        {/* Alarms Button */}
        <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 0.5 }}>
          <Button
            variant="outlined"
            onClick={() => setAlarmsDialogOpen(true)}
            sx={{
              borderColor: "#997D3D",
              color: "#ffffff",
              backgroundColor: "#997D3D",
              "&:hover": {
                borderColor: "#7a6330",
                backgroundColor: "#7a6330",
              },
              fontWeight: 400,
              fontWeight: "bold",
              px: 1.5,
              py: 0.5,
              fontSize: "0.875rem",
              textTransform: "none",
              minWidth: "auto",
              

            }}
          >
            View Alarms
          </Button>
        </Box>
        
        {/* Main Layout: Data sections */}
        <Grid container spacing={1.5} alignItems="flex-start">
          <Grid item xs={12}>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {/* Top Row: System Data, Rectifier Data, MPPT & Solar Data */}
              <Grid container spacing={1.5} alignItems="stretch">
                <Grid item xs={12} sm={4}>
                    <DataTable title="System Data">
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        System Serial No.
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.system_serial_no}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        System Make
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {/* {hupsdata.system_make} */}
                        PRATAP DIGITAL COMMUNICATIONS PVT LTD
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Total System Capacity
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.total_system_capacity} VA
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Load Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.load_current} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        AC Mains Run Hours
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.ac_mains_run_hours} Hrs
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Load Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.load_energy} Kwh
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        AC Under Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.ac_under_voltage_set} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        AC Over Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.ac_over_voltage_set} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        RM Redundant
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rm_redundant} Nos
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        RM Lacking
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rm_lacking} Nos
                      </TableCell>
                    </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          RM Replaced
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.rm_replaced} Nos
                        </TableCell>
                      </TableRow>
                    </DataTable>
                </Grid>
                
                <Grid item xs={12} sm={4}>
                    <DataTable title="Rectifier Data">
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Total Installed Rectifiers
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.total_installed_rectifiers} Nos
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of Working Rectifiers
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_working_rectifiers} Nos
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of Faulty Rectifiers
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_faulty_rectifiers} Nos
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rating of Rectifiers
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rating_of_rectifiers} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_current} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Power
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_power} W
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Output Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_output_energy} Kwh
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rectifier Unit Overload
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rectifier_unit_overload} A
                      </TableCell>
                    </TableRow>

                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Float Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.float_voltage_set} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Boost Voltage Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.boost_voltage_set} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        DC Voltage High Set
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.dc_voltage_high_set} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        SMPS Cabinet Temperature
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.smps_cabinet_temperature} °C
                        </TableCell>
                      </TableRow>
                    </DataTable>
                </Grid>
                
                <Grid item xs={12} sm={4}>
                    <DataTable title="MPPT & Solar Data" noScroll={true}>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Total Installed MPPT
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.total_installed_mppt} Nos
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of Working MPPT
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_working_mppt} Nos
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of Faulty MPPT
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_faulty_mppt} Nos
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Output Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_output_current} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Output Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_output_voltage} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Output Power
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_output_power} W
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Delivered Energy
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_delivery_energy} KWH
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Input Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_input_current} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Input Voltage
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_input_voltage} V
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        MPPT 1 Input Power
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.mppt1_input_power} W
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Solar Ultimate Capacity
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.solar_ultimate_capacity} KW
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Number of SPV Panel
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.number_of_spv_panel} Nos
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Rating of SPV Panel
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.rating_of_spv_panel} W
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Solar Current
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.solar_current} A
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: "14px" }}>
                        Solar Run Hours
                      </TableCell>
                      <TableCell sx={{ fontSize: "14px" }}>
                        {hupsdata.solar_run_hours} Hrs
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                        Solar Energy
                      </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.solar_energy} Kwh
                        </TableCell>
                      </TableRow>
                    </DataTable>
                </Grid>
              </Grid>
              
              {/* Bottom Section: Battery Data */}
              {/* <Divider sx={{ borderColor: "divider", my: 1 }} />
              <Typography
                variant="h6"
                sx={{
                  textAlign: "center",
                  mb: 1.5,
                  color: "#997D3D",
                  fontWeight: 600,
                  fontSize: { xs: "18px", sm: "20px", md: "22px" },
                }}
              >
                Battery Data
              </Typography> */}
              <Grid container spacing={1.5}>
                         <Grid item xs={12} sm={4}>
                  <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DataTable title="Battery Basic" noScroll={true}>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          Battery Capacity
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {parseBatteryCapacity(hupsdata.battery_capacity)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          Battery Current
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.battery_current} A (
                          {hupsdata.battery_current_status
                            ? "Charging"
                            : "Discharging"}
                          )
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          Battery Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.battery_voltage} V
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          Battery Run Hours
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.battery_run_hours} Hrs
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          Battery LVD
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.battery_lvd} V
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          Battery LVD Set
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.battery_lvd_set} V
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          Battery Low Alarm Voltage Set
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.battery_low_alarm_voltage_set} V
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          Battery Current Limit 1
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.battery_current_limit_1} A
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Charging Current Set Max
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_charging_current_set_max} A
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Charging Current Set Each Module
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_charging_current_set_each_module} A
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Manufacturer Name
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          PRATAP DIGITAL COMMUNICATIONS PVT LTD
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Serial No.
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_serial_no === ""
                            ? "NA"
                            : hupsdata.lib_serial_no}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Current
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_current} A (
                          {hupsdata.lib_current_status
                            ? "Charging"
                            : "Discharging"}
                          )
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Pack Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_pack_voltage} V
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>LIB SOC</TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_soc}%
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>LIB SOH</TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_soh}%
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cumulative Charging kWh
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cumulative_charging_kwh} Kwh
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cumulative Discharging kWh
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cumulative_discharging_kwh} Kwh
                        </TableCell>
                      </TableRow>
                     
            </DataTable>
          </Box>
          </Grid>
          
          <Grid item xs={12} sm={4}>
          <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
            <DataTable title="LIB Cell Voltages" noScroll={true}>
           
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Max Cell Temperature
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_max_cell_temperature} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cycle Count
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cycle_count}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 1 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell01_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 2 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell02_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 3 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell03_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 4 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell04_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 5 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell05_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 6 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell06_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 7 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell07_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 8 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell08_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 9 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell09_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 10 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell10_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 11 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell11_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 12 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell12_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 13 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell13_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 14 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell14_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 15 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell15_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell 16 Voltage
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell16_voltage} mV
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell Voltage Difference
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell_voltage_difference} mV
                        </TableCell>
                      </TableRow>
                    </DataTable>
                  </Box>
                  </Grid>
                  
                    <Grid item xs={12} sm={4}>
                    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
                    <DataTable title="LIB Temperature & Status" noScroll={true}>
                       
                    
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Total Battery Capacity
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {parseBatteryCapacity(hupsdata.lib_total_batt_capacity)}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell Temp 1
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell_temp1} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell Temp 2
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell_temp2} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell Temp 3
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell_temp3} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell Temp 4
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell_temp4} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell Temp 5
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell_temp5} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cell Temp 6
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cell_temp6} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB BMS Cooling MOSFET Temp
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_bms_cooling_mosfet_temp} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Module Ambient Temperature
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_module_ambient_temp} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Minimum Cell Temperature
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_minimum_cell_temp} °C
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Remaining Battery kWh
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_remaining_battery_kwh} Kwh
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Remaining Battery Cycles
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_remain_battery_cycles}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Estimated Backup Time
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_estimated_backup_time} Min
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Battery Installation Year
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_batt_installation_year}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Battery Installation Month
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_batt_installation_month}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Module Remaining Ah
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_module_remaining_ah} Ah
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cumulative Charge Ah
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cumulative_charging_ah} Ah
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB Cumulative Discharge Ah
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_cumulative_discharging_ah} Ah
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          LIB BMS Version No.
                        </TableCell>
                        <TableCell sx={{ fontSize: { xs: "11px", sm: "13px" } }}>
                          {hupsdata.lib_bms_version_no}
                        </TableCell>
                      </TableRow>
                    </DataTable>
                    </Box>
                  </Grid>
                </Grid>
              </Box>
            </Grid>
          </Grid>
      </Box>

      {/* Alarms Dialog */}
      <Dialog
        open={alarmsDialogOpen}
        onClose={() => setAlarmsDialogOpen(false)}
        fullScreen
        PaperProps={{
          sx: {
            m: 0,
            height: "100vh",
            maxHeight: "100vh",
            borderRadius: 0,
          },
        }}
      >
        <DialogTitle
          sx={{
            background: "linear-gradient(135deg, #997D3D 0%, #7a6330 100%)",
            color: "white",
            fontWeight: 600,
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            py: 1,
            px: 2,
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            marginBottom: 1,
          }}
        >
          <Typography variant="h6" sx={{ fontWeight: 600, letterSpacing: 0.5, fontSize: "18px" }}>
            System Alarms & Status
          </Typography>
          <IconButton
            onClick={() => setAlarmsDialogOpen(false)}
            sx={{ 
              color: "white",
              "&:hover": {
                backgroundColor: "rgba(255, 255, 255, 0.1)",
              },
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ p: 1.5, height: "calc(100vh - 100px)", overflow: "hidden", backgroundColor: "#f8f9fa" }}>
          <Grid container spacing={1.5} sx={{ height: "100%" }}>
            {/* Column 1 */}
            <Grid item xs={12} sm={6} md={4} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <TableContainer 
                component={Paper}
                sx={{ 
                  height: "100%", 
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  borderRadius: 2,
                }}
              >
                <Table size="small" sx={{ height: "100%" }}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#997D3D" }}>
                      <TableCell sx={{ 
                        fontSize: "12px", 
                        color: "white", 
                        fontWeight: 600, 
                        py: 1,
                        borderRight: "1px solid rgba(255,255,255,0.1)",
                      }}>
                        Parameter
                      </TableCell>
                      <TableCell sx={{ 
                        fontSize: "12px", 
                        color: "white", 
                        fontWeight: 600, 
                        py: 1,
                        textAlign: "center",
                      }}>
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Column 1: System & Basic Alarms */}
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>Mains</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={workParam(hupsdata.mains_fail)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>Site Battery Low</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.site_battery_low)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>FR Fail</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.fr_fail)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>System Overload</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.system_overload)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>Mains on Battery Discharge</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.mains_on_battery_discharge)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>Dc Voltage High</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.dc_voltage_high)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>SPD Fail</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.spd_fail)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>MPPT Fail</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.mppt_fail)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>AC Under Voltage</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.ac_under_voltage)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>AC Over Voltage</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.ac_over_voltage)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>Li-Ion BMS Communication Lost</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={workParam(hupsdata.li_ion_bms_communication_lost)} type="alarm" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Battery Status</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <Box
                          sx={{
                            display: "inline-block",
                            px: 1,
                            py: 0.25,
                            borderRadius: 1,
                            fontWeight: 600,
                            fontSize: "10px",
                            backgroundColor: "#e3f2fd",
                            color: "#1565c0",
                          }}
                        >
                          {battStatusMap[hupsdata.lib_batt_status] ?? "Unknown"}
                        </Box>
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Battery Error</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={hupsdata.lib_batt_error == 1 ? "Warning" : "Normal"} type="warning" />
                      </TableCell>
                    </TableRow>
                    {/* Additional LIB Warnings moved from Column 2 */}
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Low SOC Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_low_soc_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Charge Over Temperature Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_charge_over_temp_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Discharge Over Current Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_discharge_over_current_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Charge Over Current Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_charge_over_current_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Low Cell Voltage Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_low_cell_voltage_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Cell Over Voltage Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_cell_over_voltage_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Battery Low Voltage Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_batt_low_voltage_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Battery Over Voltage Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_batt_over_voltage_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            
            {/* Column 2 - Warnings */}
            <Grid item xs={12} sm={6} md={4} sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
              <TableContainer 
                component={Paper}
                sx={{ 
                  height: "100%", 
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  borderRadius: 2,
                }}
              >
                <Table size="small" sx={{ height: "100%" }}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#997D3D" }}>
                      <TableCell sx={{ 
                        fontSize: "12px", 
                        color: "white", 
                        fontWeight: 600, 
                        py: 1,
                        borderRight: "1px solid rgba(255,255,255,0.1)",
                      }}>
                        Warning Parameter
                      </TableCell>
                      <TableCell sx={{ 
                        fontSize: "12px", 
                        color: "white", 
                        fontWeight: 600, 
                        py: 1,
                        textAlign: "center",
                      }}>
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Remaining LIB Warning Alarms */}
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Mosfet Over Temperature Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_mosfet_over_temp_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Discharge Low Temperature Warning</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_discharge_low_temp_warning)} type="warning" />
                      </TableCell>
                    </TableRow>
                    {/* Additional LIB Protections moved from Column 3 */}
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Low Voltage Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_low_voltage_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Over Voltage Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_over_voltage_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Cell Over Voltage Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_cell_over_voltage_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Cell Low Voltage Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_cell_low_voltage_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    {/* Warning List Items */}
                    {warningList.map((warning) => (
                      <TableRow 
                        key={warning.key}
                        sx={{ 
                          "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, 
                          "&:hover": { backgroundColor: "#f5f5f5" } 
                        }}
                      >
                        <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>
                          {warning.label}
                        </TableCell>
                        <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                          <StatusBadge 
                            value={hupsdata[warning.key] === 1 ? "Warning" : "Normal"} 
                            type="warning" 
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
            
            {/* Column 3 - Protections */}
            <Grid item xs={12} sm={6} md={4} sx={{ height: "100%", display: "flex", flexDirection: "column"}}>
              <TableContainer 
                component={Paper}
                sx={{ 
                  height: "100%", 
                  overflow: "hidden",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  borderRadius: 2,
                }}
              >
                <Table size="small" sx={{ height: "100%" }}>
                  <TableHead>
                    <TableRow sx={{ backgroundColor: "#997D3D" }}>
                      <TableCell sx={{ 
                        fontSize: "12px", 
                        color: "white", 
                        fontWeight: 600, 
                        py: 1,
                        borderRight: "1px solid rgba(255,255,255,0.1)",
                      }}>
                        Protection Parameter
                      </TableCell>
                      <TableCell sx={{ 
                        fontSize: "12px", 
                        color: "white", 
                        fontWeight: 600, 
                        py: 1,
                        textAlign: "center",
                      }}>
                        Status
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {/* Remaining LIB Protection Alarms */}
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Charge Over Temperature Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_charge_over_temp_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Charge Low Temperature Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_charge_low_temp_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Discharge Low Temperature Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_discharge_low_temp_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Charge Over Current Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_charge_over_current_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Discharge Over Current Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_discharge_over_current_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Mosfet Over Temperature Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_mosfet_over_temp_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    <TableRow sx={{ "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, "&:hover": { backgroundColor: "#f5f5f5" } }}>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>LIB Short Circuit Protection</TableCell>
                      <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                        <StatusBadge value={alarmShow(hupsdata.lib_short_circuit_protection)} type="protection" />
                      </TableCell>
                    </TableRow>
                    {/* Protection List Items */}
                    {protectionList.map((prot) => (
                      <TableRow 
                        key={prot.key}
                        sx={{ 
                          "&:nth-of-type(odd)": { backgroundColor: "#fafafa" }, 
                          "&:hover": { backgroundColor: "#f5f5f5" } 
                        }}
                      >
                        <TableCell sx={{ fontSize: "11px", py: 0.75, fontWeight: 500, color: "#333" }}>
                          {prot.label}
                        </TableCell>
                        <TableCell sx={{ fontSize: "11px", py: 0.75, textAlign: "center" }}>
                          <StatusBadge 
                            value={hupsdata[prot.key] === 1 ? "Active" : "Normal"} 
                            type="protection" 
                          />
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions sx={{ 
          p: 1.5, 
          backgroundColor: "#f8f9fa",
          borderTop: "1px solid #e0e0e0",
          display: "flex",
          justifyContent: "flex-end",
        }}>
          <Button
            onClick={() => setAlarmsDialogOpen(false)}
            variant="contained"
            sx={{
              backgroundColor: "#997D3D",
              color: "white",
              px: 4,
              py: 1,
              fontWeight: 600,
              textTransform: "none",
              fontSize: "14px",
              borderRadius: 2,
              boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
              "&:hover": {
                backgroundColor: "#7a6330",
                boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
              },
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default ViewMore;
